import React from "react";
import DriverNavbar from "../components/driver/DriverNavbar";
import DriverFooter from "../components/driver/DriverFooter";
import { ThemeProvider } from "styled-components";
import { driverTheme } from "../theme";

import { Box } from "@chakra-ui/react";

const DriverLayout = ({ children }) => {
  return (
    <ThemeProvider theme={driverTheme}>
      <Box
        bg={driverTheme.background} // Using Chakra UI Box for background color
        color={driverTheme.color}   // Using Chakra UI Box for text color
        minH="100vh"                // Set the minimum height to full viewport height
        display="flex"
        flexDirection="column"      // Stack content vertically
        px={0}                      // Remove padding on the x-axis
      >
        <DriverNavbar />
        <Box pt="72px" pb="72px">
          {children}
        </Box>
        <DriverFooter />
      </Box>
    </ThemeProvider>
  );
};

export default DriverLayout;
